import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LuIconModule } from 'lu-icon';

export interface LuSearchOptions {
	field?: string;
	placeHolder?: string;
	label?: string;
	btnLabel?: string;
}
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-search',
	templateUrl: 'lu-search.component.html',
	styleUrls: ['./lu-search.component.scss'],
	imports: [LuIconModule, TranslateModule, CommonModule, FormsModule],
	standalone: true
})
export class LuSearchComponent {
	@Input() searchOptions: LuSearchOptions;
	@Input() value: string;
	@Output() triggerSearch: EventEmitter<{ value: string; event: Event }> = new EventEmitter<{
		value: string;
		event: Event;
	}>();
	@Output() valueChange: EventEmitter<{ value: string; event: Event }> = new EventEmitter<{
		value: string;
		event: Event;
	}>();
	@Output() inputClicked: EventEmitter<void> = new EventEmitter<void>();
	@Output() clearSearch: EventEmitter<void> = new EventEmitter<void>();
	uniqueId: string = Math.random().toString(36);
	searchValue = '';

	onClearSearch(search: HTMLInputElement, event: Event): void {
		event.stopPropagation(); // Prevents the event from bubbling up the DOM tree, to prevent closing the dropdown
		search.value = '';
		this.searchValue = '';
		this.triggerSearch.emit({ value: search.value, event });
		this.clearSearch.emit();
	}
}
